import { render, staticRenderFns } from "./PlayerStarSpecialistHired.vue?vue&type=template&id=611b7464&scoped=true&"
import script from "./PlayerStarSpecialistHired.vue?vue&type=script&lang=js&"
export * from "./PlayerStarSpecialistHired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b7464",
  null
  
)

export default component.exports